import { TAvailableConfigValues } from '@customTypes/common';

export interface IDeltaBufferEstimatorConfig {
  bufferDeltaFractionToDetectFall: number;
  numberOfFallsToDetect: number;
}

export const defaultDeltaBufferEstimatorConfig: IDeltaBufferEstimatorConfig = {
  bufferDeltaFractionToDetectFall: 0.1,
  numberOfFallsToDetect: 2,
};

export const availableDeltaBufferEstimatorConfigValues: TAvailableConfigValues<IDeltaBufferEstimatorConfig> = {};
